<template>
    <v-row v-if="!isReadOnly" no-gutters class="gc-5 pb-4">
        <v-btn variant="text" color="primary" data-cy="select-all" @click="selectAll">
            {{ $t('select_all') }}
        </v-btn>
        <v-btn variant="text" color="primary" data-cy="deselect-all" @click="deselectAll">
            {{ $t('deselect_all') }}
        </v-btn>
    </v-row>
    <v-row no-gutters>
        <v-col cols="12" md="10" lg="6">
            <div class="grid-container">
                <div v-for="(value, key) in formData.productTypeEnabled" :key="key">
                    <v-checkbox
                        v-model="formData.productTypeEnabled[key]"
                        hide-details
                        :label="$t(`productType.${key}`)"
                        :data-cy="key"
                    />
                </div>
            </div>
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
    const isReadOnly = inject('isReadOnly', ref(false))

    const selectAll = () => {
        Object.keys(formData.value.productTypeEnabled).forEach(key => (formData.value.productTypeEnabled[key] = true))
    }

    const deselectAll = () => {
        Object.keys(formData.value.productTypeEnabled).forEach(key => (formData.value.productTypeEnabled[key] = false))
    }
</script>
<style lang="scss" scoped>
    .grid-container {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 0 15px;
    }
</style>
